import { atom } from 'recoil'

export const autoPlayState = atom<boolean | undefined>({
  key: 'auto_play',
  default: undefined,
})
